<div class="program-author-info" *ngIf="authorDetails; let author">
  <ptl-icon class="author-icon" [icon]="LucideUser" size="xs"></ptl-icon>

  <ng-container *ngIf="author.displayConfig?.authorName && !author.displayConfig?.organizationName">
    <span class="author-name">{{ author.name }}</span>
  </ng-container>

  <ng-container *ngIf="author.displayConfig?.organizationName && !author.displayConfig?.authorName">
    <span class="author-name">{{ author.organization }}</span>
  </ng-container>

  <ng-container *ngIf="author.displayConfig?.authorName && author.displayConfig?.organizationName">
    <span class="author-name">{{ author.organization }}</span>
    <span class="author-name-secondary">· {{ author.name }}</span>
  </ng-container>

  <ng-container *ngIf="!author.displayConfig?.authorName && !author.displayConfig?.organizationName">
    <span class="author-name">{{ author.name }}</span>
  </ng-container>
</div>
